module.exports = __webpack_public_path__ + "img/61-green.d406f4a4.svg";